import React, { useState } from "react";
import DataTable from "components/DataTable";
import PageWrapperForm from "components/PageWrapperForm";
import { useTableDataWithPost } from "hooks/useTableWithPost";
import { MainServiceData } from "config/tableConfigs";
import MainServiceFormModal from "./components/MainServiceFormModal";
import DeleteModal from "components/DeleteModal";
import { useSession } from "hooks/useSession";

const MainServicePage = () => {
  const [modalShow, setModalShow]       = useState(false);
  const [modalMode, setModalMode]       = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh]           = useState(0);
  const { userid } = useSession();

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/main_service_action",
    MainServiceData,
    formdata,
    refresh
  );

  const handleAddUser  = () => { setModalMode("add"); setSelectedUser(null); setModalShow(true); };
  const handleEditUser = (user) => { setModalMode("edit"); setSelectedUser(user); setModalShow(true); };
  const handleDelete   = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const el = document.getElementById("deleteMainService");
      if (el) window.bootstrap.Modal.getOrCreateInstance(el).show();
    }, 100);
  };

  return (
    <div>
      <PageWrapperForm
        config={MainServiceData}
        handleOnclick={handleAddUser}
        buttonTitle="Add Service"
      >
        <DataTable
          config={MainServiceData}
          tableData={tableData}
          onEdit={handleEditUser}
          onDelete={handleDelete}
        />
      </PageWrapperForm>

      <MainServiceFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={() => { setRefresh(p => p + 1); setModalShow(false); }}
      />

      <DeleteModal
deleteid={selectedUser?.id}
        id="deleteMainService"
        title="Delete Service"
        message="Are you sure you want to delete this service?"
        apiUrl="https://pro.mokshiq.in/main_service_action"
        onSuccess={() => setRefresh(p => p + 1)}
      />
    </div>
  );
};

export default MainServicePage;